module.exports = "<qms-navigation-menu (selectedChanged)=\"onSelectedChanged($event)\"> <qms-users-management-navigation-menu> </qms-users-management-navigation-menu> <qms-faculties-management-navigation-menu> </qms-faculties-management-navigation-menu> <qms-queues-handling-navigation-menu> </qms-queues-handling-navigation-menu> </qms-navigation-menu> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/components/management/management-navigation-menu/management-navigation-menu.component.html
// module id = 263
// module chunks = 0